export default __webpack_public_path__ + "static/media/upArrowGrey.1c4d9237.svg";